import { render, staticRenderFns } from "./ClassificationListDialog.vue?vue&type=template&id=146b5235"
import script from "./ClassificationListDialog.vue?vue&type=script&lang=js"
export * from "./ClassificationListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports